import * as React from "react";
import { Switch, Route } from "react-router-dom";
import MarginContainer from '../components/toc/marginFiles/marginContainer/marginContainer';

const MarginFilesRouting = () => {
	return (
		<Switch>
			<Route path="/marginfiles/:fileType/:subParam?" component={MarginContainer} />
		</Switch>
	);
};
export default MarginFilesRouting;
